import { definePlayerFeature } from "../../feature.js";
import { exitFullscreen, isFullscreen } from "../../presentation/fullscreen.js";
import { exitPictureInPicture, isPictureInPicture, isPictureInPictureCapable, isPictureInPictureEnabled, requestPictureInPicture } from "../../presentation/pip.js";
import { listen } from "@videojs/utils/dom";
import { hasMetadata, isMediaSourceCapable } from "@videojs/media";
//#region src/dom/store/features/pip.ts
const pipFeature = definePlayerFeature({
	name: "pip",
	state: ({ target }) => ({
		pip: false,
		pipAvailability: "unavailable",
		async requestPictureInPicture() {
			const { media, container } = target();
			if (!isMediaSourceCapable(media) || !hasMetadata(media)) return;
			if (isFullscreen(container, media)) await exitFullscreen(media);
			return requestPictureInPicture(media);
		},
		async exitPictureInPicture() {
			const { media } = target();
			return exitPictureInPicture(media);
		},
		async togglePictureInPicture() {
			const { media, container } = target();
			if (isPictureInPicture(media)) return exitPictureInPicture(media);
			if (!isMediaSourceCapable(media) || !hasMetadata(media)) return;
			if (isFullscreen(container, media)) await exitFullscreen(media);
			return requestPictureInPicture(media);
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		const supported = isPictureInPictureEnabled() && isPictureInPictureCapable(media);
		const sync = () => set({
			pip: isPictureInPicture(media),
			pipAvailability: supported ? isMediaSourceCapable(media) && hasMetadata(media) ? "available" : "unavailable" : "unsupported"
		});
		sync();
		listen(media, "enterpictureinpicture", sync, { signal });
		listen(media, "leavepictureinpicture", sync, { signal });
		listen(media, "loadstart", sync, { signal });
		listen(media, "loadedmetadata", sync, { signal });
		listen(media, "emptied", sync, { signal });
		if ("webkitPresentationMode" in media) listen(media, "webkitpresentationmodechanged", sync, { signal });
	}
});
//#endregion
export { pipFeature };

//# sourceMappingURL=pip.js.map